/**
 * The MIME type a browser reports for a file the user picked. It is protocol
 * text with a `type/subtype` grammar, so the family check happens here.
 */
export function isImageMediaType(mediaType: string): boolean {
  return mediaType.startsWith("image/");
}
